import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '@clerk/clerk-react';
import { PageLoading } from '@/components/PageLoading';

const Landing = lazy(() => import('@/pages/Landing'));

export function RootRedirect() {
  const { isLoaded, userId } = useAuth();

  if (!isLoaded) {
    return null;
  }

  if (userId) {
    return <Navigate to="/projects" replace />;
  }

  return (
    <Suspense fallback={<PageLoading />}>
      <Landing />
    </Suspense>
  );
}
